import { render } from "./OUpload.vue?vue&type=template&id=2e962118&scoped=true"
import script from "./OUpload.vue?vue&type=script&lang=js"
export * from "./OUpload.vue?vue&type=script&lang=js"

import "./OUpload.vue?vue&type=style&index=0&id=2e962118&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e962118"]])

export default __exports__